// extracted by mini-css-extract-plugin
export default {"burgerMenuIcon":"Header_burgerMenuIcon__Czd5g","header":"Header_header__pEbJR"};